import React, { useMemo} from "react";
import { useTable, useSortBy } from "react-table";
import { useHistory, useLocation } from 'react-router-dom';
import "./table.css";
import "tachyons"
const Table = ({headers, content, onclick, custom}) => {

  const columns = useMemo(() => headers, [headers]);
  const data = useMemo(() => content, [content]);
  const location = useLocation();
  const history = useHistory();

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  return (
    <div className="">
      <div className="overflow-auto">
       <table className={`main-table-thead ${custom && "custom-table-thread" }`} {...getTableProps()} cellSpacing="0">
       <thead >
         {headerGroups.map((headerGroup) => (
          <tr className="stripe-dark" {...headerGroup.getHeaderGroupProps()} >
            {headerGroup.headers.map((column) => (
              <th className="fw6 tl pa3 bg-white" {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render("Header")}
                {/* Add a sort direction indicator */}
                <span>
                  {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody  className="lh-copy" {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
          
            <tr className="stripe-dark" {...row.getRowProps()} 
             //onclick props is only for dashboard
              onClick={ onclick && (() => onclick(row.original.id))}
                // onClick={onclick ? () => onclick(row.original.id) :
                // () => history.push(`${location.pathname}/${row.original.id}`)}
               >
              {row.cells.map((cell) => {
                return ( 
                  cell.column.Header === "" ?
                <td className="pa3 tc" {...cell.getCellProps()}>{cell.render("Cell")}</td> 
                : 
                <td className="pa3" 
                  //if onclick was passed as props then we ignore histoty push
                  onClick={() => (!onclick ? history.push(`${location.pathname}/${row.original.id}`) : "")} {...cell.getCellProps()}>
                  {cell.render("Cell")}
                </td>
                )
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
      </div>
    </div>
  );
};

export default Table;